import enUS from './en-US';

export default {
  ...enUS,
  'navBar.lang': 'Språk',
  'layout.user.link.help': 'Hjälp',
  'layout.user.link.privacy': 'Integritet',
  'layout.user.link.terms': 'Villkor',
  'component.logout.label': 'Logga ut',
  'component.globalHeader.search': 'Sök',
  'component.globalHeader.help': 'Hjälp',
  'component.globalHeader.notification': 'Aviseringar',
  'component.globalHeader.message': 'Meddelanden',
  'component.globalHeader.event': 'Händelser',
  'component.noticeIcon.clear': 'Rensa',
  'component.noticeIcon.cleared': 'Rensat',
  'component.noticeIcon.empty': 'Inga aviseringar',
  'component.noticeIcon.view-more': 'Visa fler',
  'component.refresh': 'Uppdatera',
  'component.copyAddress': 'Kopiera adress',
  'component.copySuccess': 'Adressen har kopierats',
  'component.endOfList': 'Slut på listan',
  'menu.home': 'Hem',
  'menu.login': 'Logga in',
  'menu.register': 'Registrera',
  'menu.org': 'Instrumentpanel',
  'menu.org.home': 'Instrumentpanel',
  'menu.org.analysis': 'Analys',
  'menu.management': 'Hantering',
  'menu.management.site-list': 'Webbplatser',
  'menu.management.players': 'Spelare',
  'menu.management.players.detail': 'Spelarinformation',
  'menu.management.game': 'Spel',
  'menu.management.game.category': 'Spelkategorier',
  'menu.management.contents': 'Innehåll',
  'menu.settings.finance': 'Ekonomi',
  'menu.account': 'Konto',
  'menu.settings': 'Konto och inställningar',
  'menu.account.center': 'Kontocenter',
  'menu.account.settings': 'Kontoinställningar',
  'menu.account.logout': 'Logga ut',
  'pages.login.accountLogin.tab': 'Medlemsområde',
  'pages.login.failure': 'Inloggningen misslyckades. Försök igen!',
  'pages.login.username.placeholder': 'Medlems-id / användarnamn',
  'pages.login.username.required': 'Ange ditt användarnamn!',
  'pages.login.password.placeholder': 'Lösenord',
  'pages.login.password.required': 'Ange ditt lösenord!',
  'pages.login.rememberMe': 'Kom ihåg mig',
  'pages.login.forgotPassword': 'Glömt lösenordet?',
  'pages.login.submit': 'Logga in',
  'pages.login.registerAccount': 'Skapa konto',
  'pages.login.pleaseVerifyCaptcha': 'Bekräfta att du inte är en robot.',
  'app.pwa.offline': 'Du är offline nu',
  'app.pwa.serviceworker.updated': 'Nytt innehåll är tillgängligt',
  'app.pwa.serviceworker.updated.ok': 'Uppdatera',
};
